/**
 * UI状態管理ストア
 *
 * ローディング・エラー表示・モーダル等のUI状態管理
 */

import { create } from 'zustand';
import type { PieceType } from '@/types/game';

/**
 * UIストア インターフェース
 */
interface UIStore {
  // === State ===
  isLoading: boolean;
  loadingMessage: string;
  errorMessage: string | null;
  selectedPiece: PieceType | null;

  // === Actions ===
  setLoading: (isLoading: boolean, message?: string) => void;
  setError: (message: string | null) => void;
  setSelectedPiece: (piece: PieceType | null) => void;
  clearError: () => void;
}

/**
 * UIストア作成
 */
export const useUIStore = create<UIStore>((set) => ({
  // === Initial State ===
  isLoading: false,
  loadingMessage: '処理中...',
  errorMessage: null,
  selectedPiece: null,

  // === Actions ===

  /**
   * ローディング状態設定
   *
   * @param isLoading ローディング状態
   * @param message ローディングメッセージ
   */
  setLoading: (isLoading: boolean, message: string = '処理中...') => {
    set({ isLoading, loadingMessage: message });
  },

  /**
   * エラーメッセージ設定
   *
   * @param message エラーメッセージ
   */
  setError: (message: string | null) => {
    set({ errorMessage: message });
  },

  /**
   * 選択中の駒設定
   *
   * @param piece 選択された駒
   */
  setSelectedPiece: (piece: PieceType | null) => {
    set({ selectedPiece: piece });
  },

  /**
   * エラークリア
   */
  clearError: () => {
    set({ errorMessage: null });
  },
}));
